import { Provider } from 'react-redux'
import React from 'react'
import { render } from 'react-dom'

import RouteFilters from './components/container/RouteFilters.jsx'
import { gettext, modals } from '@bikemap/js/services'
import { TranslationProvider } from '@bikemap/components'

/**
 * Show the route filters in a modal.
 * @param {import("redux").Store} store
 * @param {() => void} onClose
 */
export function showFiltersModal(store, onClose) {
    modals.show('search-filters', {
        init: modal => render((
            <Provider store={store}>
                <TranslationProvider translate={gettext}>
                    <RouteFilters />
                </TranslationProvider>
            </Provider>
        ), modal.body),
        onClose,
    })
}
